import { Box, Breadcrumbs, Heading2, Link, Page } from "@nulogy/components";
import PageDescription from "components/pages/PageDescription";
import React from "react";

export default function PageWithBreadcrumbs({
  children,
  title,
  extraBreadcrumbs,
  description,
  simpleView = false,
  ...props
}) {
  return (
    <Box ml={simpleView ? "-24px" : "0"} mt={simpleView ? "-24px" : "0"}>
      <Page
        breadcrumbs={
          simpleView ? null : (
            <Breadcrumbs>
              <Link href="/" underline={false}>
                Home
              </Link>
              {extraBreadcrumbs?.map(({ label, path }) => (
                <Link href={path} key={label} underline={false}>
                  {label}
                </Link>
              ))}
            </Breadcrumbs>
          )
        }
        title={simpleView ? "" : title}
        {...props}
      >
        {simpleView && <Heading2>{title}</Heading2>}
        {description && <PageDescription description={description} />}
        {children}
      </Page>
    </Box>
  );
}
